import {TextButton} from "js/common/views/inputs/buttons";
import React from "react";
import * as Branding from "js/common/branding-constants";
import {Checkbox, FormControlLabel} from "@mui/material";
import * as Auditor from "js/common/auditor";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const AiAssistantStartOverDialog = ({onStartOver, onCancel}) => {
  const [showThisMessageAgain, setShowThisMessageAgain] = React.useState(true);
  const {theme} = React.useContext(CustomThemeContext);

  const handleCancel = () => {
    localStorage.setItem("showAiAssistantStartOverWarning", showThisMessageAgain.toString());
    if (!showThisMessageAgain) {
      Auditor.audit("ai-assistant-reset-dialog-hidden");
    }
    onCancel();
  };

  const handleStartOver = () => {
    localStorage.setItem("showAiAssistantStartOverWarning", showThisMessageAgain.toString());
    if (!showThisMessageAgain) {
      Auditor.audit("ai-assistant-reset-dialog-hidden");
    }
    onStartOver();
  };

  return <div style={{padding: "0.5rem 0", overflow: "hidden", textAlign: "center"}}>

    <i
        className="bhi-caution-circle"
        style={{fontSize: 58, lineHeight: 1, display: "inline-block", color: theme.palette.warning.main}} />

    <p style={{marginTop: "0.75rem", padding: "0 1rem"}}>
      <strong style={{fontSize: "1.2rem", fontWeight: 600}}>Are you sure you want to start over?</strong><br />
      <span style={{fontSize: "0.9rem"}}>
        By starting over, you will lose your current conversation with {Branding.aiAssistantName}.
      </span>
    </p>

    <div style={{display: "flex", justifyContent: "center"}}>
      <FormControlLabel
          control={
            <Checkbox
                checked={!showThisMessageAgain}
                onChange={(e) => setShowThisMessageAgain(!e.target.checked)}
                size="small"
            />
          }
          label="Do not show this message again"
          style={{marginBottom: "1rem", marginTop: "0rem"}}
      />
    </div>

    <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
      <TextButton
          key="ai-startover-modal-cancel"
          style={{marginRight: "1rem", marginLeft: "0.5rem", backgroundColor: theme.palette.background.paper}}
          label={"Cancel"}
          onClick={handleCancel}
      />
      <TextButton
          key="ai-startover-modal-startover"
          type="alert"
          label="Start Over"
          style={{marginLeft: "0.5rem", color: theme.palette.text.inverted, marginRight: "0.5rem"}}
          onClick={handleStartOver}
      />
    </div>
  </div>;
};

export default AiAssistantStartOverDialog;